/** Type icons from the handoff (`Ads Manager Filter.dc.html`, screen 9):
 *  bars = Metrics, tag = Label, globe = Country; Rules (fix2) = the
 *  sidebar's ⚡ (`I.zap` path, same stroke) at chip-icon size. Sized by the
 *  caller. */

export function MetricsIcon({ size = 13 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <rect x="3" y="12" width="4.5" height="8" rx="1.2" />
      <rect x="9.75" y="7" width="4.5" height="13" rx="1.2" />
      <rect x="16.5" y="3.5" width="4.5" height="16.5" rx="1.2" />
    </svg>
  );
}

export function LabelIcon({ size = 13 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M11.6 2.6H4a1.4 1.4 0 0 0-1.4 1.4v7.6c0 .37.15.73.41.99l8.6 8.6c.55.55 1.43.55 1.98 0l7.6-7.6a1.4 1.4 0 0 0 0-1.98l-8.6-8.6a1.4 1.4 0 0 0-.99-.41zM7 8.4a1.4 1.4 0 1 1 0-2.8 1.4 1.4 0 0 1 0 2.8z" />
    </svg>
  );
}

export function CountryIcon({ size = 13 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18" />
      <path d="M12 3c2.6 2.4 4 5.6 4 9s-1.4 6.6-4 9c-2.6-2.4-4-5.6-4-9s1.4-6.6 4-9z" />
    </svg>
  );
}

export function RulesIcon({ size = 13 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M13 2 4 14h7l-1 8 9-12h-7l1-8z" />
    </svg>
  );
}

/** «Split by devices»: a phone next to a tablet, same stroke as the rest. */
export function DevicesIcon({ size = 13 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="2.5" y="6" width="7" height="13" rx="1.6" />
      <rect x="11.5" y="3" width="10" height="16" rx="1.8" />
      <path d="M5.5 16.5h1" />
      <path d="M15.8 16h1.4" />
    </svg>
  );
}

export function FunnelIcon({ size = 20 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 5h18l-7 9v5l-4 2v-7z" />
    </svg>
  );
}

export function TypeIcon({ tab, size }: { tab: "metrics" | "label" | "country" | "rules"; size?: number }) {
  if (tab === "metrics") return <MetricsIcon size={size} />;
  if (tab === "label") return <LabelIcon size={size} />;
  if (tab === "rules") return <RulesIcon size={size} />;
  return <CountryIcon size={size} />;
}
